/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown>, date: NonNullable<unknown> }} Trialbannerdescription2Inputs */

const en_trialbannerdescription2 = /** @type {(inputs: Trialbannerdescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your ${i?.tier} trial is active until ${i?.date}. Upgrading to a higher plan will end the trial immediately.`)
};

const de_trialbannerdescription2 = /** @type {(inputs: Trialbannerdescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein ${i?.tier}-Testabo ist aktiv bis ${i?.date}. Ein Wechsel auf einen höheren Plan beendet das Testabo sofort.`)
};

/**
* | output |
* | --- |
* | "Your {tier} trial is active until {date}. Upgrading to a higher plan will end the trial immediately." |
*
* @param {Trialbannerdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const trialbannerdescription2 = /** @type {((inputs: Trialbannerdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trialbannerdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_trialbannerdescription2(inputs)
	return de_trialbannerdescription2(inputs)
});
export { trialbannerdescription2 as "trialBannerDescription" }